// extracted by mini-css-extract-plugin
module.exports = {"tabs-bar":"styles_tabs-bar__j7lkA","tabsBar":"styles_tabs-bar__j7lkA","line-separator":"styles_line-separator__dbYm4","lineSeparator":"styles_line-separator__dbYm4"};